import React, { useState } from 'react';
import { Alert, Box, Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import AddIcon from '@mui/icons-material/Add';
import { useData } from './DataProviderContext';
import { ACTION_WRITING_GUIDANCE, LONG_ACTION_GUIDANCE, isLongAction } from './actionTextGuidance';
import { LockedButton } from './SignedInLock';


const JourneySuggestion = ({ selectedStep, mode = 'create', editMode = false, existingData = null , objective}) => {
    const [open, setOpen] = useState(false);
    const [actionText, setActionText] = useState('');
    const { dataState, dispatch } = useData();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setActionText('');
    };

    return (
        <div>
            {/* Button to open the dialog */}
            {dataState?.guestJourneyStatus === 'preview' ? (
                <LockedButton variant="outlined" color="primary" startIcon={<AddIcon />} data-testid="add-action" sx={{ minHeight: 44 }}>Add action</LockedButton>
            ) : (
                <Button variant="outlined" color="primary" onClick={handleClickOpen} startIcon={<AddIcon />} data-testid="add-action" sx={{ minHeight: 44 }}>Add action</Button>
            )}
            {/* Dialog component */}
            <Dialog open={open} onClose={handleClose}
                fullScreen={isMobile}
                fullWidth
                maxWidth={'md'}
                PaperProps={{
                    component: 'form',
                    onSubmit: (event) => {
                        // invoke firebase here?
                        // put in Quuee to submit
                        event.preventDefault();
                        const formData = new FormData(event.currentTarget);
                        const formJson = Object.fromEntries(formData.entries());
                        const suggestion = formJson.suggestion;
                        // console.log(suggestion);
                        // updateClientSideJourney(selectedStep, suggestion);
                        const tempJourney = { step_Id: selectedStep, index: 0, value: suggestion };
                        console.log("Update client side :\n" + JSON.stringify(tempJourney));
                        dispatch({ type: 'TAKE_SUGGESTION', payload: tempJourney });
                        handleClose();
                    },
                }}>
                <Box
                    data-testid="add-action-content-column"
                    sx={{ width: '100%', maxWidth: 720, mx: 'auto', px: { xs: 2, sm: 4, md: 6 }, boxSizing: 'border-box' }}
                >
                    <DialogTitle sx={{ px: 0 }}>{objective?.text || 'Add action'}</DialogTitle>
                    <DialogContent sx={{ px: 0, pt: 0 }}>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                            What is one action that helps you move this step forward? {objective?.description || ''}
                        </Typography>
                        <TextField
                            autoFocus
                            required
                            margin="dense"
                            id="name"
                            name="suggestion"
                            data-testid="new-action-input"
                            label="Action"
                            type="text"
                            fullWidth
                            multiline
                            rows={4}
                            variant="outlined"
                            value={actionText}
                            onChange={(event) => setActionText(event.target.value)}
                            helperText={ACTION_WRITING_GUIDANCE}
                        />
                        {isLongAction(actionText) ? (
                            <Alert severity="info" variant="outlined" data-testid="long-action-guidance" sx={{ mt: 1 }}>
                                {LONG_ACTION_GUIDANCE}
                            </Alert>
                        ) : null}
                    </DialogContent>
                    <DialogActions sx={{ px: 0 }}>
                        <Button type="submit" data-testid="suggest-action">Suggest</Button>
                        <Button onClick={handleClose} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Box>
            </Dialog>
        </div>
    );
};

export default JourneySuggestion;
